import { render, staticRenderFns } from "./SdsTableEditHistory.vue?vue&type=template&id=fade4ba6&scoped=true"
import script from "./SdsTableEditHistory.vue?vue&type=script&setup=true&lang=ts"
export * from "./SdsTableEditHistory.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SdsTableEditHistory.vue?vue&type=style&index=0&id=fade4ba6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fade4ba6",
  null
  
)

export default component.exports